import type { Person } from '@vigeo/shared';
import { HrWorkflowPanel } from '@/features/hr-workflow';
import { usePersonStyles } from './styles.js';

/** Step 7. Moved unchanged from `pages/PersonPage.tsx` (#462 §5). */
export function OrientationStep({ person, canEdit }: { readonly person: Person; readonly canEdit: boolean }) {
  const styles = usePersonStyles();
  return <div className={styles.page}>
    <HrWorkflowPanel person={person} canEdit={canEdit} view="orientation" />
  </div>;
}
